import React, { Component } from "react";
import { Switch, Route, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";

import { I18nextProvider } from "react-i18next";

import i18n from "./i18n";

import { ThemeProvider } from "styled-components";

import Container from "ia.react.container";
import Clearfix from "ia.react.clearfix";
import { ExtranetLayout } from "ia-react-extranet-layout";
import GlobalStyle from "ia.react.injectglobal";

import LandingPage from "./components/LandingPage";
import SectionIntro from "./components/SectionIntro";
import SectionOne from "./components/SectionOne";
import SectionTwo from "./components/SectionTwo";
import SectionThree from "./components/SectionThree";
import SectionFour from "./components/SectionFour";
import SectionFive from "./components/SectionFive";
import SectionSix from "./components/SectionSix";
import SectionSummary from "./components/SectionSummary";
import SectionConfirmation from "./components/SectionConfirmation";
import * as fnolData from "./components/fnol.json";

class App extends Component {
  interview = null;
  constructor(props) {
    super();

    this.interview = JSON.parse(JSON.stringify(fnolData));
  }

  clearInterview = () => {
    sessionStorage.clear();
    this.interview = JSON.parse(JSON.stringify(fnolData));
  };

  render() {
    return (
      <ThemeProvider theme={{ theme: "Corpo" }}>
        <ExtranetLayout>
          <Provider store={store}>
            <I18nextProvider i18n={i18n}>
              <div className="injectIaStyles">
                <GlobalStyle />
                <Container>
                  <Clearfix>
                    <HashRouter>
                      <Switch>
                        <Route exact path="/" render={props => (<LandingPage interview={this.interview} {...props}/>)} />
                        <Route exact path="/SectionIntro" render={props => (<SectionIntro interview={this.interview} {...props}/>)}/>
                        <Route path="/SectionOne" render={props => (<SectionOne interview={this.interview}step={0} clearInterview={this.clearInterview} {...props} />)}/>
                        <Route path="/SectionTwo" render={props => (<SectionTwo interview={this.interview}step={1} clearInterview={this.clearInterview} {...props} />)}/>
                        <Route path="/SectionThree" render={props => (<SectionThree interview={this.interview} step={2} clearInterview={this.clearInterview} {...props} /> )}/>
                        <Route path="/SectionFour" render={props => (<SectionFour interview={this.interview} step={3} clearInterview={this.clearInterview} {...props} />)}/>
                        <Route path="/SectionFive" render={props => (<SectionFive interview={this.interview} step={4} clearInterview={this.clearInterview} {...props} /> )}/>
                        <Route path="/SectionSix" render={props => (<SectionSix interview={this.interview} step={5} clearInterview={this.clearInterview} {...props}/>)}/>
                        <Route path="/SectionSummary" render={props => (<SectionSummary interview={this.interview} step={6} clearInterview={this.clearInterview}{...props}/>)}/>
                        <Route path="/SectionConfirmation" render={props => (<SectionConfirmation interview={this.interview} {...props} />)}/>
                      </Switch>
                    </HashRouter>
                  </Clearfix>
                </Container>
              </div>
            </I18nextProvider>
          </Provider>
        </ExtranetLayout>
      </ThemeProvider>
    );
  }
}

export default App;
